export default "__VITE_ASSET__CKuMkMCj__"